<div #documents id="documents" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty?.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty?.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="py-8 flex flex-col sm:w-auto md:w-1/2  bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty?.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty?.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div class="px-8">
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
              <p>Two years of employment information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="verifastEnabled" class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Income & Identity</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/verifast" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div>
        </div>
        <div *ngIf="!showUploadForm" class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{currentApplicationStep}}/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="w-full">
              <h2 class="text-lg font-bold my-6">Verify Income</h2>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!showUploadForm && showUploadOptions"
        class="grid grid-rows-2 gap-10 px-8 sm:grid-cols-2 sm:grid-rows-1 sm:gap-12 sm:px-20">
        <div class="text-center flex flex-col bg-beige-tricon p-4">
          <div>
            <div class="dashboard-card">
              <div class="card-content">
                <i class="material-icons text-6xl">upload_file</i>
                <div>
                  <p class="application-edit-button">
                    <button mat-flat-button color="accent" class="px-4" (click)="showUploadFormClick()">Upload
                      Documents</button>
                  </p>
                  <p class="mt-4">
                    Manually upload your bank statements, pay stubs, or other proof of income
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center flex flex-col bg-beige-tricon p-4">
          <div>
            <div class="dashboard-card">
              <div class="card-content">
                <i class="material-icons text-6xl">account_balance</i>
                <div>
                  <p class="application-edit-button">
                    <button mat-flat-button color="accent" class="px-4" (click)="importFromBankClick()">Import
                      from Bank</button>
                  </p>
                  <p class="mt-4">
                    Log into your online banking system and conveniently import your bank statements
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="px-8" *ngIf="showUploadForm">
        <app-documents-upload></app-documents-upload>
      </div>
    </div>
  </div>
</div>
